import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const openshiftPlugin = createPlugin({
  id: 'openshift',
  routes: {
    root: rootRouteRef,
  },
});

export const OpenshiftPage = openshiftPlugin.provide(
  createRoutableExtension({
    name: 'OpenshiftPage',
    component: () =>
      import('./components/OpenshiftPage').then(m => m.OpenshiftPage),
    mountPoint: rootRouteRef,
  }),
);
